export default __webpack_public_path__ + "static/media/btn21.cb8ae321.webp";